import CustomInput from "./CustomInput";

const NUMBERS = /^[0-9]*$/;

class NumberInput extends CustomInput {
  transform = value =>
    this.props.hasOwnProperty("maxlength")
      ? value.trim().substr(0, this.props.maxlength)
      : value.trim();

  validate = value => NUMBERS.test(value);
}

export default NumberInput;
